import React, { useEffect, useState } from 'react';

import { apiContainer } from '@vlabs/api-bindings';
import { useTranslation } from 'react-i18next';

import st from './PassportCard.module.sass';

interface PassportDataField {
  title: string;
  value: string;
}

interface PassportImageObject {
  image_id: string;
  url: string;
}

export type PassportDataDTO = Record<string, PassportDataField>;
export type PassportImagesDTO = PassportImageObject[];

interface PassportCardProps {
  passportData: PassportDataDTO;
  images: PassportImagesDTO;
}

export function PassportCard({
  passportData,
  images,
}: PassportCardProps): JSX.Element {
  const { t } = useTranslation();
  const [imageURLs, setImageURLs] = useState<string[] | undefined>(undefined);

  useEffect(() => {
    const fetchData = async () => {
      if (!images?.length) return;

      try {
        const responses = await Promise.all(
          images.map(async (image) => {
            // @ts-expect-error luna client types
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return apiContainer.lunaClient.images.getURL(image.url);
          }),
        );

        setImageURLs(responses);
      } catch (e) {
        console.error(e);
      }
    };

    fetchData();
  }, [images]);

  return (
    <div className={st.PassportCard}>
      <div className={st.Images}>
        {imageURLs?.map((src) => (
          <img
            alt={`passport_${src}`}
            key={src}
            src={src}
          />
        ))}
      </div>
      <div className={st.DataTable}>
        {Object.entries(passportData).map(([key, { title, value }], index, array) => {
          return (
            <React.Fragment key={key}>
              <div className={st.DataEntry}>
                <div className={st.Title}>
                  {t(`monokit:passport card.${title}`, { defaultValue: title })}
                </div>
                <div className={st.Data}>
                  {value}
                </div>
              </div>
              {index < array.length - 1 && <div className={st.Divider} />}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
